import styled from 'styled-components';
import shopping_cart from '../../../atoms/Icon/img/shopping-cart.svg';
import credit_card from '../../../atoms/Icon/img/credit_card.svg';
import date from '../../../atoms/Icon/img/date.svg';
import cvc from '../../../atoms/Icon/img/cvc.svg';
var c_c = "url(".concat(credit_card, ");");
var card_date = "url(".concat(date, ");");
var card_cvc = "url(".concat(cvc, ");");
export var Input = styled.input.withConfig({
  displayName: "style__Input",
  componentId: "tlwpce-0"
})(["height:50%;width:", ";color:black;border-top-right-radius:", ";border-top-left-radius:", ";border-bottom-right-radius:", ";border-bottom-left-radius:", ";padding-left:40px;border:2px solid;background-image:", ";background-repeat:no-repeat;border-color:rgba(14,19,24,0.2);&:focus{outline:0;border-color:#4cbeff;}"], function (props) {
  return props.small ? '50%' : '100%';
}, function (props) {
  return props.small ? '0px' : '4px';
}, function (props) {
  return props.small ? '0px' : '4px';
}, function (props) {
  return props.right ? '4px' : '0px';
}, function (props) {
  return props.left ? '4px' : '0px';
}, function (props) {
  return props.cvc ? card_cvc : props.date ? card_date : c_c;
});
export var InputContainer = styled.div.withConfig({
  displayName: "style__InputContainer",
  componentId: "tlwpce-1"
})(["position:relative;height:70%;width:auto;margin-left:12px;margin-right:12px;"]);
export var CheckoutTitle = styled.div.withConfig({
  displayName: "style__CheckoutTitle",
  componentId: "tlwpce-2"
})(["font-weight:600;line-height:2;position:relative;height:25px;width:auto;margin-left:12px;color:rgba(14,19,24,0.9);margin-right:12px;"]);
export var CheckoutContainer = styled.div.withConfig({
  displayName: "style__CheckoutContainer",
  componentId: "tlwpce-3"
})(["height:140px;width:100%;margin-bottom:15px;"]);
export var Label = styled.div.withConfig({
  displayName: "style__Label",
  componentId: "tlwpce-4"
})(["height:25px;line-height:100%;width:", ";margin:auto;margin-left:10px;font-weight:", ";color:rgba(14,19,24,0.9);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;text-align:left;z-index:", ";"], function (props) {
  return props.width ? props.width : '100%';
}, function (props) {
  return props.bold ? 'bold' : 'normal';
}, function (props) {
  return props.price ? '98' : '99';
});
export var PriceLabel = styled.div.withConfig({
  displayName: "style__PriceLabel",
  componentId: "tlwpce-5"
})(["height:100%;line-height:100%;width:", ";margin:auto;color:rgba(14,19,24,0.9);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;text-align:right;background-color:#fff;"], function (props) {
  return props.width ? props.width : '100%';
});
export var PlaceHolder = styled.div.withConfig({
  displayName: "style__PlaceHolder",
  componentId: "tlwpce-6"
})(["position:relative;float:left;top:50%;left:50%;transform:translate(-50%,-50%);color:rgba(14,19,24,0.5);"]);
export var Item = styled.div.withConfig({
  displayName: "style__Item",
  componentId: "tlwpce-7"
})(["height:25px;width:80%;margin:auto;margin-left:10px;color:rgba(14,19,24,0.9);flex-direction:row;display:flex;"]);
export var ExitButton = styled.div.withConfig({
  displayName: "style__ExitButton",
  componentId: "tlwpce-8"
})(["width:", ";cursor:pointer;height:", ";line-height:", ";text-align:center;background:none;border:none;font-style:normal;font-weight:300;font-size:", ";color:rgba(14,19,24,0.6);margin:auto;"], function (props) {
  return props.small ? '10%' : '20%';
}, function (props) {
  return props.small ? '20px' : '100%';
}, function (props) {
  return props.small ? '10px' : '40px';
}, function (props) {
  return props.small ? '10px' : '20px';
});
export var IconContainer = styled.div.withConfig({
  displayName: "style__IconContainer",
  componentId: "tlwpce-9"
})(["display:flex;justify-content:center;margin-left:5%;margin-right:5%;"]);
export var HeaderTitle = styled.div.withConfig({
  displayName: "style__HeaderTitle",
  componentId: "tlwpce-10"
})(["position:relative;line-height:40px;font-weight:600;color:black;width:70%;"]);
export var Header = styled.div.withConfig({
  displayName: "style__Header",
  componentId: "tlwpce-11"
})(["top:0;display:flex;position:relative;flex-direction:row;background-color:white;border-radius:1%;height:40px;width:100%;border-bottom:1px solid rgba(14,19,24,0.3);"]);
export var PanelContainer = styled.div.withConfig({
  displayName: "style__PanelContainer",
  componentId: "tlwpce-12"
})(["display:", ";box-shadow:0px 4px 4px rgba(0,0,0,0.25);position:absolute;background-color:white;fill:currentColor;border-radius:1%;height:430px;width:290px;margin-top:7px;z-index:999;right:179px;"], function (props) {
  return props.active ? 'inline-block' : 'none';
});
export var ButtonContainer = styled.div.withConfig({
  displayName: "style__ButtonContainer",
  componentId: "tlwpce-13"
})(["position:relative;border-radius:10%;height:", ";width:", ";"], function (props) {
  return props.height ? props.height : '35px';
}, function (props) {
  return props.width ? props.width : '35px';
});
export var Button = styled.button.withConfig({
  displayName: "style__Button",
  componentId: "tlwpce-14"
})(["height:", ";width:", ";border-radius:10%;padding-left:5px;padding-right:0;padding-top:5px;border-color:", ";background:", ";&:focus{outline:0;}", ":hover &{border:none;background:rgba(0,0,0,0.15);}"], function (props) {
  return props.height ? props.height : '40px';
}, function (props) {
  return props.width ? props.width : '40px';
}, function (props) {
  return props.active ? 'rgba(0, 0, 0, 0.015)' : 'rgba(0, 0, 0, 0.015)';
}, function (props) {
  return props.active ? 'rgba(0, 0, 0, 0.15)' : 'rgba(0, 0, 0, 0.015)';
}, ButtonContainer);
export var ShoppingCartButtonContainer = styled.div.withConfig({
  displayName: "style__ShoppingCartButtonContainer",
  componentId: "tlwpce-15"
})(["position:relative;border-radius:10%;width:", ";margin-top:5px;margin-left:15px;"], function (props) {
  return props.width ? props.width : '35px';
});
export var ShoppingCartButton = styled.button.withConfig({
  displayName: "style__ShoppingCartButton",
  componentId: "tlwpce-16"
})(["width:", ";height:", ";padding-top:0px;padding-left:4px;background-color:#fff;border-color:#fff;box-shadow:#fff;&:focus{outline:0;border-color:#fff;}border-radius:4px;", ":hover &{background:rgba(0,0,0,0.115);background-color:rgba(0,0,0,0.115);}"], function (props) {
  return props.width ? props.width : '35px';
}, function (props) {
  return props.height ? props.height : '35px';
}, ShoppingCartButtonContainer);
export var PaymentButtonContainer = styled.div.withConfig({
  displayName: "style__PaymentButtonContainer",
  componentId: "tlwpce-17"
})(["height:100px;width:70%;padding-top:20px;text-align:center;margin:auto;"]);
export var PaymentButton = styled.button.withConfig({
  displayName: "style__PaymentButton",
  componentId: "tlwpce-18"
})(["width:180px;height:36px;left:866px;top:703px;background:#9de042;border:1px solid #9de042;box-sizing:border-box;box-shadow:0px 4px 4px rgba(0,0,0,0.25);line-height:normal;font-weight:600;color:#ffffff;&:focus{outline:0;box-sizing:border-box;box-shadow:0px 4px 4px rgba(0,0,0,0.25);}", ":hover &{background:#9de042;box-shadow:0px 4px 4px rgba(0,0,0,0.025);}"], PaymentButtonContainer);
export var ItemContainer = styled.div.withConfig({
  displayName: "style__ItemContainer",
  componentId: "tlwpce-19"
})(["background-color:white;height:250px;width:100%;border-bottom:1px solid rgba(0,0,0,0.15);flex-direction:column;overflow-y:scroll;max-height:400px;padding:5px;"]);
export var ShoppingCartIcon = styled.div.withConfig({
  displayName: "style__ShoppingCartIcon",
  componentId: "tlwpce-20"
})(["height:35px;width:100%;margin:auto;background-image:", ";border-radius:4px;"], shopping_cart);
export var TotalTitle = styled.div.withConfig({
  displayName: "style__TotalTitle",
  componentId: "tlwpce-21"
})(["font-weight:600;line-height:2;position:relative;height:25px;width:78%;margin-left:12px;color:rgba(14,19,24,0.9);margin-right:12px;text-align:right;"]);